import { useEffect, useState } from 'react';

type Theme = 'dark' | 'light';

export function useTheme() {
 const [theme, setTheme] = useState<Theme>('dark');

 useEffect(() => {
  // Check for saved theme preference or default to 'dark'
  const savedTheme = localStorage.getItem('theme') as Theme;
  const initialTheme = savedTheme || 'dark';

  setTheme(initialTheme);
  applyTheme(initialTheme);
 }, []);

 const applyTheme = (newTheme: Theme) => {
  const root = document.documentElement;

  if (newTheme === 'light') {
   root.classList.add('light');
  } else {
   root.classList.remove('light');
  }
 };

 const toggleTheme = () => {
  const newTheme = theme === 'dark' ? 'light' : 'dark';
  setTheme(newTheme);
  applyTheme(newTheme);
  localStorage.setItem('theme', newTheme);
 };

 return {
  theme,
  toggleTheme,
  setTheme: (newTheme: Theme) => {
   setTheme(newTheme);
   applyTheme(newTheme);
   localStorage.setItem('theme', newTheme);
  },
 };
}
